import axios from 'axios'
import Vue from 'vue'
import './util/rem';
import '../src/assets/css/nomal.css'
import App from './App.vue'
import router from './router'
import store from './store/index'

Vue.config.productionTip = false

axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
